import { Injectable } from '@angular/core';
import moment from 'moment';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import saveAs from '../../../utils/download';
import { AssetExportService } from '../../../services/asset-export.service';
import { LogService } from '../../../services/log.service';

interface ExportDisplayFlags {
  showRegions: boolean;
  showAgency: boolean;
  showFocus: boolean;
  showLength: boolean;
  showTypes: boolean;
  showFormat: boolean;
}

@Injectable()
export class AssetExportOperationsService {
  constructor(
    private readonly assetExportService: AssetExportService,
    private readonly logService: LogService,
    private readonly activeModal: NgbActiveModal
  ) {}

  public exportToPDF(pdfData: any[], displayFlags: ExportDisplayFlags, onError?: () => void): void {
    const data = {
      ...displayFlags,
      assets: pdfData,
    };

    this.assetExportService.generatePDF({ templateName: 'asset-list', data }).subscribe({
      next: (blob: Blob) => {
        saveAs(blob, 'asset-list.pdf');
        this.activeModal.close();
      },
      error: (error: any) => {
        this.logService.logError(
          error as Error,
          'Failed to export Asset List PDF: ' + (error as { message?: string })?.message
        );
        if (onError) onError();
      },
    });
  }

  public exportToExcel(sheetData: string[][], onComplete?: () => void, onError?: () => void): void {
    const request = {
      sheetName: 'Assets',
      data: sheetData,
    };

    this.assetExportService.generateXLSX(request).subscribe({
      next: (blob: Blob) => {
        const fileName: string = `asset-list-${moment().format('YYYY-MM-DD-HHmm')}.xlsx`;
        saveAs(blob, fileName);
        this.activeModal.close();
      },
      error: (error: any) => {
        this.logService.logError(
          error as Error,
          'Failed to export Asset List Excel: ' + (error as { message?: string })?.message
        );
        if (onError) onError();
      },
      complete: () => {
        if (onComplete) onComplete();
      },
    });
  }

  public exportToCSV(csvContent: string): void {
    const blob: Blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const fileName: string = `asset-list-${moment().format('YYYY-MM-DD-HHmm')}.csv`;
    saveAs(blob, fileName);
    this.activeModal.close();
  }
}
